<!-- //
动态环行图
@auth xuyd
@date 2024-05-01
//-->
<template>
  <dv-active-ring-chart class="widget-view" :config="viewProps.dataConfig">
  </dv-active-ring-chart>
</template>

<script>
import ApiDesignApi from "@/api/datasvc/apiDesign.api";

export default {
  name: 'WidgetActiveRingView',
  components: {},
  data() {
    return {}
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    },
    datasourceProps() {
      return this.widgetProps.datasourceProps;
    }
  },
  watch: {
    'widgetProps.datasourceProps': {
      handler: function (val) {
        this.handleFetchData().then(data => this.handleFillData(data)).then(()=>{});
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.handleFetchData().then(data => this.handleFillData(data)).then(()=>{});
  },
  methods: {
    /**
     * 获取数据
     */
    handleFetchData() {
      return new Promise((resolve, reject) => {
        if (this.datasourceProps.datasourceType === 'STATIC') {
          // [{},{}]
          let respData = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType].data;
          resolve(respData);
        } else if (this.datasourceProps.datasourceType === 'API') {
          let dataConfig = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType];
          if (dataConfig && dataConfig.datasource) {
            let reqParams = (typeof dataConfig.reqParams === 'string') ? JSON.parse(dataConfig.reqParams) : dataConfig.reqParams;
            ApiDesignApi.runApi(dataConfig.datasource, reqParams).then(resp => {
              resolve(resp.data);
            });
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },
    /**
     * 填充数据
     */
    handleFillData(respData) {
      let dataList = (typeof respData === 'string') ? JSON.parse(respData) : respData;
      let list = dataList.map(item => {
        return {name: item[this.datasourceProps.dataMapping['name']], value: item[this.datasourceProps.dataMapping['value']]};
      });
      let dataConfig = {...this.viewProps.dataConfig};
      dataConfig.data = list;
      // console.log("-------handleFillData-------->", JSON.stringify(list));
      this.viewProps.dataConfig = dataConfig;
    },
  }
}

</script>
<style lang="less" scoped>
.widget-view {
  width: 100%;
  height: 100%;
}
</style>
